



















import Vue from 'vue'

export default Vue.extend({
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    heading: {
      type: String,
      default: 'Heading',
    },
    width: {
      type: Number,
      default: 400,
    },
    headerHeight: {
      type: Number,
      default: 80,
    },
    allowClosing: {
      type: Boolean,
      default: true,
    }
  },
  computed:{
    panelWidth(){
      return 400
    },
  }
})
